/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'ai-mate.chat-error-banner.description': 'Din chatthistorik sparas i upp till 30 dagar.',
  'ai-mate.chat-error-banner.title': 'Starta ny chatt',
  'ai-mate.chat-error.description': 'Försök att <btn>läsa in chatten igen</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nått högsta antalet förfrågningar. Försök igen senare.',
  'ai-mate.chat-error.rate-limited-title': 'För många förfrågningar',
  'ai-mate.chat-error.rovo-inactive-description':
    'Det verkar som att Rovo inte är aktiverat på webbplatsen. <link>Ställer in Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo är inaktivt',
  'ai-mate.chat-error.title': 'Vi vet inte vad som gick fel',
  'conversation-assistant-button.label': 'Chatt',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chatt',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Fråga AI om detta',
  'highlight-actions.rovo-chat-explain-option.text': 'Förklara',
  'highlight-actions.rovo-chat-explain-prompt': 'Förklara detta: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chattrekommendationer',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Öppna chatt',
  'highlight-actions.rovo-chat-summarize-option.text': 'Sammanfatta',
  'highlight-actions.rovo-chat-summarize-prompt': 'Sammanfatta detta: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chatt',
  'horizontal-scroll-container.scroll-left': 'Bläddra åt vänster',
  'horizontal-scroll-container.scroll-right': 'Bläddra åt höger',
};
